function findSegmentsIntersection(
  p1: google.maps.LatLng,
  p2: google.maps.LatLng,
  q1: google.maps.LatLng,
  q2: google.maps.LatLng
) {
  const a1 = p2.lat() - p1.lat();
  const b1 = p1.lng() - p2.lng();
  const c1 = a1 * p1.lng() + b1 * p1.lat();

  const a2 = q2.lat() - q1.lat();
  const b2 = q1.lng() - q2.lng();
  const c2 = a2 * q1.lng() + b2 * q1.lat();

  const determinant = a1 * b2 - a2 * b1;

  if (determinant === 0) {
    return null;
  }

  const lng = (b2 * c1 - b1 * c2) / determinant;
  const lat = (a1 * c2 - a2 * c1) / determinant;

  const eps = 1e-12;

  if (
    lng > Math.max(p1.lng(), p2.lng()) + eps ||
    lng < Math.min(p1.lng(), p2.lng()) - eps ||
    (lat > Math.max(p1.lat(), p2.lat()) + eps ||
      lat < Math.min(p1.lat(), p2.lat()) - eps) ||
    (lng > Math.max(q1.lng(), q2.lng()) + eps ||
      lng < Math.min(q1.lng(), q2.lng()) - eps) ||
    (lat > Math.max(q1.lat(), q2.lat()) + eps ||
      lat < Math.min(q1.lat(), q2.lat()) - eps)
  ) {
    return null;
  }

  return new google.maps.LatLng(lat, lng);
}

export function bringToBounds(
  pos1: google.maps.LatLng,
  pos2: google.maps.LatLng,
  bounds: google.maps.LatLngBounds
) {
  let ne = bounds.getNorthEast();
  let sw = bounds.getSouthWest();
  // Augment 3x the side of bounds
  ne = new google.maps.LatLng(
    ne.lat() + (ne.lat() - sw.lat()),
    ne.lng() + (ne.lng() - sw.lng())
  );
  sw = new google.maps.LatLng(
    sw.lat() - (ne.lat() - sw.lat()),
    sw.lng() - (ne.lng() - sw.lng())
  );

  const extendedBounds = new google.maps.LatLngBounds(sw, ne);
  if (extendedBounds.contains(pos1) && extendedBounds.contains(pos2)) {
    return { pos1, pos2 };
  }

  const nw = new google.maps.LatLng(ne.lat(), sw.lng());
  const se = new google.maps.LatLng(sw.lat(), ne.lng());

  const n = findSegmentsIntersection(pos1, pos2, nw, ne);
  const s = findSegmentsIntersection(pos1, pos2, sw, se);
  const e = findSegmentsIntersection(pos1, pos2, ne, se);
  const w = findSegmentsIntersection(pos1, pos2, nw, sw);

  if (!n && !e && !s && !w) {
    return { pos1, pos2: pos1 };
  }

  // The reverse order of terms (n, e, s, w) is paramount
  return {
    pos1: extendedBounds.contains(pos1) ? pos1 : n || e || s || w,
    pos2: extendedBounds.contains(pos2) ? pos2 : w || s || e || n
  };
}

export default bringToBounds;
